import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import * as fromApp from '../../../store';
import { selectAppConfigState } from '../../../store/app-config/app-config.selectors';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: 'fc-app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
})
export class AppFooterComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  helpPhone = '';
  helpEmail = '';

  constructor(
    readonly store: Store<fromApp.AppState>,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.store
      .select(selectAppConfigState)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: appConfig => {
          this.helpPhone = appConfig.config['fc_help_phone'];
          this.helpEmail = appConfig.config['fc_help_email'];
        },
        error: (error: any) => {
          throw error;
        },
      });
  }

  goToFC() {
    window.open('https://www.landyield.com/', '_blank', 'noopener');
  }

  navigate(url: string) {
    window.open(url, '_blank', 'noopener');
  }
}
